var _path, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcoReleaseNoteNotification = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0887 8.8957C10.3187 8.48323 9.00012 6.8956 9.00012 5C9.00012 4.08034 9.31049 3.23317 9.83219 2.55751C9.35607 2.22543 8.81721 1.9679 8.23023 1.80466V1.20437C8.2708 0.574069 7.78394 0.0338095 7.14494 0.00379515C6.50593 -0.036224 5.95822 0.444006 5.92779 1.07431V1.20437V1.80466C3.60506 2.40495 2.02277 4.51596 2.1242 6.87709V10.949C2.1242 11.2092 2.02277 11.4593 1.8402 11.6494L0.623047 12.93V13.7804H13.6465V12.93L12.4192 11.6394C12.2468 11.4593 12.1454 11.2192 12.1454 10.9691L12.0887 8.8957ZM7.43908 16.0015H7.08408C6.22193 15.9514 5.52207 15.3111 5.42064 14.4707H8.63594C8.64609 14.6808 8.60551 14.8809 8.51423 15.061C8.3418 15.5412 7.93608 15.8914 7.43908 16.0015Z",
    fill: "#8D939C"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 5,
    r: 3.45,
    fill: "#E20A16"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcoReleaseNoteNotification);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ico_release_note_notification.1836d3a32dfae0638d6701a3e01719b9.svg";